export default __webpack_public_path__ + "static/media/warning--koala-crossing--g3.31ba34fb.png";